import { styled } from '@mui/material';

export const Input = styled('input')(({ theme }) => ({
  width: '100%',
  minWidth: 0,
  height: 34,
  padding: '0 8px',
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.novotalk.$inputBorderColor}`,
  borderRadius: 4,
  color: theme.palette.novotalk.$textColorDarkBlue,
  backgroundColor: theme.palette.novotalk.$backgroundColor,
  fontSize: 14,
  '&:focus': {
    borderColor: theme.palette.novotalk.$inputBorderColorActive,
    outline: 'none',
  },
  '&:disabled': {
    opacity: 0.65,
  },
  '&[aria-invalid="true"]': {
    borderColor: theme.palette.novotalk.$errorColor,
  },
  '&::placeholder': {
    color: theme.palette.novotalk.$textColorDisabledLight,
  },
}));

export const HelperText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  display: 'block',
  marginTop: 3,
  color: error
    ? theme.palette.novotalk.$errorColor
    : theme.palette.novotalk.$textColorDisabled,
  fontSize: 11,
}));